import React from "react";
import "./games.scss";
import { Link } from "react-router-dom";
const Games = () => {
  return (
    <>
      <section className="maingames">
        <p className="gamespara">Games</p>
        <div className="maincardsparent">
          <Link to="/play" className="innercard">
            <div className="img">
              <img src="/assets/gameone.png" alt="img" className="cardimage" />
              <h2 className="headodd">Dice</h2>
            </div>
{/* 
            <div className="activemain">
              <p className="playerpara">Active Players</p>
              <div className="playernumber">
                <p className="numberpara">321</p>
                <span className="circle"></span>
              </div>
            </div> */}
          </Link>
          <Link to="/tothemoon" className="innercard">
            <div className="img">
              <img src="/assets/gametwo.png" alt="img" className="cardimage" />
              <h2 className="headodd">Crash</h2>
            </div>
            {/* <div className="activemain">
              <p className="playerpara">Active Players</p>
              <div className="playernumber">
                <p className="numberpara">398</p>
                <span className="circle"></span>
              </div>
            </div> */}
          </Link>
          <div to="" style={{cursor: 'not-allowed'}} className="innercard">
            <div className="img">
              <img src="/assets/gamethree.png" alt="img" className="cardimage" />
              <h2 className="headodd">Plinko <span className="comingtext">Coming soon</span></h2>
            </div>
            {/* <div className="activemain">
              <p className="playerpara">Active Players</p>
              <div className="playernumber">
                <p className="numberpara">0</p>
                <span className="circle"></span>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Games;